import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import staffImage from "../../../files/nurse.png";
import {
  Card,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
const _ = require("lodash");
function fullname(cell, row) {
  const profileImage =  row.user && row.user.profileImage ?  process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + row.user.profileImage  : staffImage
  return (
    <div className={row.user && row.user.isActive ? "" : " text-danger"}>
      <span>
        <img src={profileImage} className="mr-2" alt="image" />
        {capitalize(row.lname)} {capitalize(row.fname)}
      </span>
    </div>
  );
}
function capitalize(cell) {
  if (cell) {
    return cell.charAt(0).toUpperCase() + cell.slice(1);
  }
}
function isApproved(cell, row) {
  return (
    <span>
      {cell ? (
        <label className="badge badge-gradient-success">ACCOUNT CREATED</label>
      ) : (
        <label className="badge badge-warning">PENDING INVITATION</label>
      )}
    </span>
  );
}

function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span className="mb-2">{filterElement}</span>

      {column.text}
      {sortElement}
    </div>
  );
}
function showButtons(cell, row, rowIndex, formatExtraData) {
  return (
    <div>
      {!row.isCreated && (
        <button
          type="button"
          onClick={() => formatExtraData.delete(row._id)}
          className="btn btn-danger btn-fw"
        >
          Delete Invitation
        </button>
      )}
    </div>
  );
}
const rowComponent = (
  row,
  users,
  expectations,
  userInputChange,
  expectationInputChange,
  openPatientModal,
  openExpectationModal
) => (
  <Row className="justify-content-center">
    <Col xs="auto" className="text-center">
      <Button
        color="primary"
        onClick={() => openPatientModal(row)}
        className="btn btn-primary btn-fw btn-lg"
        style={{ minWidth: '200px', margin: '5px' }}
      >
        <i className="fa fa-user-plus mr-2"></i>
        Pick Patient to Assign
      </Button>
    </Col>
    <Col xs="auto" className="text-center">
      <Button
        color="success"
        onClick={() => openExpectationModal(row)}
        className="btn btn-success btn-fw btn-lg"
        style={{ minWidth: '200px', margin: '5px' }}
      >
        <i className="fa fa-tasks mr-2"></i>
        Pick Expectation to Assign
      </Button>
    </Col>
  </Row>
);
const StaffList = (props, context) => {
  const [patientModalOpen, setPatientModalOpen] = useState(false);
  const [expectationModalOpen, setExpectationModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const openPatientModal = (row) => {
    setSelectedRow(row);
    setPatientModalOpen(true);
  };

  const openExpectationModal = (row) => {
    setSelectedRow(row);
    setExpectationModalOpen(true);
  };

  const closePatientModal = () => {
    setPatientModalOpen(false);
    setSelectedRow(null);
  };

  const closeExpectationModal = () => {
    setExpectationModalOpen(false);
    setSelectedRow(null);
  };

  return (
    <div className="scrollbar-table-cls">
      <BootstrapTable
        wrapperClasses="table-responsive"
        keyField="_id"
        noDataIndication="No Data Found"
        data={props.staff}
        expandRow={{
          renderer: (row) =>
            rowComponent(
              row,
              props.usersOfferedAccess,
              props.expectations,
              props.userInputChange,
              props.expectationInputChange,
              openPatientModal,
              openExpectationModal
            ),

          showExpandColumn: true,
        }}
        filter={filterFactory()}
        columns={[
          {
            dataField: "fname",
            text: "Name",
            formatter: fullname,
            sort: true,
            headerFormatter: priceFormatter,
          },
          {
            dataField: "email",
            text: "Email",
            sort: true,
            headerFormatter: priceFormatter,
          },
          {
            dataField: "isCreated",
            text: "Status",
            formatter: isApproved,
            headerFormatter: priceFormatter,
          },
          {
            dataField: "action",
            text: "Action",
            formatter: showButtons,
            headerFormatter: priceFormatter,
            formatExtraData: {
              delete: props.deleteInvitation,
            },
          },
        ]}
      />

      {/* Patient Assignment Modal */}
      <Modal isOpen={patientModalOpen} toggle={closePatientModal} size="lg">
        <ModalHeader toggle={closePatientModal}>Pick Patient to Assign</ModalHeader>
        <ModalBody>
          {selectedRow && (
            <Card body style={{ marginTop : '-20px'}}>
              <Form>
                <FormGroup>
                  <Row>
                    {props.usersOfferedAccess.map((object, i) => {
                      const isUserFound = _.includes(selectedRow.assignedUsers, object._id);
                      return (
                        <Col xs="12" md={4} key={object._id}>
                          <CustomInput
                            type="checkbox"
                            defaultChecked={isUserFound}
                            id={object._id}
                            name={object._id}
                            onChange={(e) => props.userInputChange(e, selectedRow._id)}
                            label={object.fname + " " + object.lname}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </FormGroup>
              </Form>
            </Card>
          )}
        </ModalBody>
      </Modal>

      {/* Expectation Assignment Modal */}
      <Modal isOpen={expectationModalOpen} toggle={closeExpectationModal} size="lg">
        <ModalHeader toggle={closeExpectationModal}>Pick Expectation to Assign</ModalHeader>
        <ModalBody>
          {selectedRow && (
            <Card body style={{ marginTop : '-20px'}}>
              <Form>
                <FormGroup>
                  <div>
                    {props.expectations && props.expectations.map((object, i) => {
                      const expectationFound = _.includes(
                        selectedRow.assignedExpectationsReference,
                        object._id
                      );
                      return (
                        <CustomInput
                          key={object._id}
                          type="checkbox"
                          defaultChecked={expectationFound}
                          id={object._id}
                          value={object._id}
                          name={object._id}
                          onChange={(e) => props.expectationInputChange(e, selectedRow._id, object)}
                          label={object.name}
                        />
                      );
                    })}
                  </div>
                </FormGroup>
              </Form>
            </Card>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default StaffList;
